import script from "./DecUseZh.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecUseZh.vue?vue&type=script&setup=true&lang=ts"

import "./DecUseZh.vue?vue&type=style&index=0&id=519e5d93&lang=scss"

const __exports__ = script;

export default __exports__